if (!customElements.get('password-modal')) {
  class PasswordModal extends HTMLElement {
    constructor() {
      super();
      this.modal = null;
      this.trigger = null;
      this.closeBtn = null;
      this.backdrop = null;
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.handleBackdropClick = this.handleBackdropClick.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    connectedCallback() {
      this.modal = this.querySelector('.password-modal');
      this.trigger = document.querySelector('[data-password-modal-trigger]');
      this.closeBtn = this.querySelector('.password-modal__close');
      this.backdrop = this.querySelector('.password-modal__backdrop');

      if (this.trigger) this.trigger.addEventListener('click', this.handleTriggerClick);
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.handleCloseClick);
      if (this.backdrop) this.backdrop.addEventListener('click', this.handleBackdropClick);
      document.addEventListener('keydown', this.handleKeyDown);

      if (this.modal && this.modal.dataset.hasErrors === 'true') {
        this.open();
      }
    }

    disconnectedCallback() {
      if (this.trigger) this.trigger.removeEventListener('click', this.handleTriggerClick);
      if (this.closeBtn) this.closeBtn.removeEventListener('click', this.handleCloseClick);
      if (this.backdrop) this.backdrop.removeEventListener('click', this.handleBackdropClick);
      document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleTriggerClick(e) {
      e.preventDefault();
      this.open();
    }

    handleCloseClick() {
      this.close();
    }

    handleBackdropClick() {
      this.close();
    }

    handleKeyDown(e) {
      if (!this.modal || !this.modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') return this.close();
      if (e.key === 'Tab') {
        const focusable = this.modal.querySelectorAll('button, input, [tabindex]:not([tabindex="-1"])');
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    open() {
      if (!this.modal) return;
      this.modal.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      const input = this.modal.querySelector('.password-modal__input');
      if (input) {
        setTimeout(() => input.focus(), 50);
      }
    }

    close() {
      if (!this.modal) return;
      this.modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (this.trigger) this.trigger.focus();
    }
  }

  customElements.define('password-modal', PasswordModal);
}
